var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zidingyi"},[_c('span',[_c('span',{staticClass:"mark"},[_c('img',{attrs:{"src":_vm.title==='账号'?require('../assets/sgyuser.png'):require('../assets/sgypassword.png')}})])]),_c('input',{attrs:{"type":_vm.type,"placeholder":_vm.placeholder},on:{"input":function($event){return _vm.updateVal($event.target.value)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }